// extracted by mini-css-extract-plugin
module.exports = {"light_ui-label-color":"#070d17","dark_ui-label-color":"#d1d1d1"};